<template>
  <section class="[ c-filters-parent ]" :class="[customClass ? customClass : '', theme ? `c-filters-parent--${theme}`:'']">
    <div class="[ o-wrapper o-wrapper--center ]">
      <form class="c-filters" :class="{'c-filters--center': center}">
        <p v-if="theme === 'side' && (Object.values(selectedFilters).filter(f => f !== null).length && selectedFilters.Brands !== null && Object.values(selectedFilters).filter(f => f !== null).length !== selectedFilters.Brands.length) || (Object.values(selectedFilters).filter(f => f !== null).length && selectedFilters.Brands === null)" class="u-font-weight-medium u-text-uppercase u-margin-left-small">{{ $t('product_overview.filters.active_filters') }}</p>
        <div v-if="theme === 'side' && (Object.values(selectedFilters).filter(f => f !== null).length && selectedFilters.Brands !== null && Object.values(selectedFilters).filter(f => f !== null).length !== selectedFilters.Brands.length) || (Object.values(selectedFilters).filter(f => f !== null).length && selectedFilters.Brands === null)" class="c-nav--horizontal u-margin-small">
          <template v-for="(item, key, index) in selectedFilters" v-if="item && key !== 'Brands'">
            <button
              class="c-button c-button--white c-button--icon button-remove-item"
              style="box-shadow: 0px 4px 6px -1px rgba(0,0,0,0.1) , 0px 2px 4px -1px rgba(0,0,0,0.06) "
              v-for="i in item"
              @click.prevent="deleteItem(i, key)">
              <svgicon name="cross" width="12"></svgicon>
              <span>{{filters[index].name + ': ' }} {{ i.DisplayValue === 'true' || i.DisplayValue === 'false' ? $t('global.' + i.DisplayValue) :  i.DisplayValue.charAt(0).toUpperCase() + i.DisplayValue.slice(1) }}</span>
            </button>
          </template>
        </div>
        <button class="c-button--remove-filters" v-if="theme === 'side' && (Object.values(selectedFilters).filter(f => f !== null).length && selectedFilters.Brands !== null && Object.values(selectedFilters).filter(f => f !== null).length !== selectedFilters.Brands.length) || (Object.values(selectedFilters).filter(f => f !== null).length && selectedFilters.Brands === null)" @click.prevent="uncheckAll">{{ $t('product_overview.filters.remove_filters') }}</button>
        <slot></slot>
        <slot name="search-button"></slot>
      </form>
      <slot name="button"></slot>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import VFilterInput from '@/components/form/filters/FilterInput'
  import VFilterSelect from '@/components/form/filters/FilterSelect'
  import VFilterCheckbox from '@/components/form/filters/FilterCheckbox'
  import VFilterBrands from '@/components/form/filters/FilterBrands'
  import VCheckbox from '@/components/form/Checkbox'
  import Stickyfill from 'stickyfilljs';
  import VFilterCheckboxProduct from '@/components/form/filters/FilterCheckboxProduct'



  // Register subcomponents
  Vue.component('v-checkbox', VCheckbox);
  Vue.component('v-filter-input', VFilterInput);
  Vue.component('v-filter-select', VFilterSelect);
  Vue.component('v-filter-checkbox', VFilterCheckbox);
  Vue.component('v-filter-brands', VFilterBrands);
  Vue.component('v-filter-checkbox-product', VFilterCheckboxProduct);

  export default {
    props: {
      'custom-class': String,
      center: {type: Boolean, default: false},
      theme: {type: String, default: 'grey'},
      selectedFilters: {type: Object, default: () => { return {}}},
      filters: {type: [Array, Boolean]},
    },
    mounted() {
      const elements = document.querySelectorAll('.u-pos-sticky');
      Stickyfill.add(elements);
    },
    methods: {
      uncheckAll() {
        let query = {};

        let brands = this.$route.query.Brands;
        if (brands) {
          query['Brands'] = brands;
        }

        let pageSize = this.$route.query.pageSize;
        if (pageSize) {
          query['pageSize'] = pageSize;
        }

        if (JSON.stringify(this.$router.currentRoute.query) !== JSON.stringify(query)) {
          this.$router.push({path: this.$route.path, query});
        }
      },
      deleteItem(item, key) {
        let query = {}

        for (const i in this.$route.query){
          if (i === key) {
            query[key] = this.$route.query[key].split(",").filter((x) => x !== item.Value).toString() ? this.$route.query[key].split(",").filter((x) => x !== item.Value).toString() : null
          } else {
            query[i] = this.$route.query[i] ? this.$route.query[i] : null;
          }
        }

       // query[key] = query[key].split(",").filter((x) => x !== item.Value).toString();
        this.$router.push({path: this.$route.path, query: query});
        sessionStorage.setItem('customerFilters', window.location.search);
        //router.go(1)
      },
    }
  }
</script>

<style lang="scss" scoped>

  // Import private settings & functions
  @import "~@/assets/scss/private";

  .c-filters-parent {
    &--grey {
      background-color: palette(color-neutral, x-light);
    }
    &--white {
      background-color: white;
      .c-filters {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: em($global-spacing-unit-medium);
        margin-bottom: em($global-spacing-unit-medium);
      }
    }

    &--side {
      background-color: transparent;
      .c-filters {
        background-color: palette(color-neutral, x-light);
        display: block;
        padding: em($global-spacing-unit-small) em($global-spacing-unit-tiny);
      }
    }
  }

  .c-button--remove-filters {
    background: none;
    border: none;
    color: $color-alpha;
    box-shadow:none !important;
    text-decoration: underline;
    font: inherit;
    line-height: 1;
    font-size: 14px;
    margin-bottom: em($global-spacing-unit) !important;
    margin-left: em($global-spacing-unit-small) !important;
  }

  .c-nav--horizontal {
    gap: em($global-spacing-unit-small);
  }

  .button-remove-item {
    padding: em($global-spacing-unit-tiny) !important;
  }

  .c-filters {
    $gutter: em(15px);
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: em(20px) - $gutter/2 0;
    margin-left: -$gutter/2;

    > * {
      margin: $gutter/2;
    }

    &--center {
      justify-content: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/form/filters/Filters.vue